import React from "react";
import img1 from "../assets/images/sidom/fotos/Nosotros/iconos_web_vieja/clients-1.svg";
import img3 from "../assets/images/sidom/fotos/Nosotros/iconos_web_vieja/trophies-1.svg";
import img4 from "../assets/images/sidom/fotos/Nosotros/iconos_web_vieja/trust-1.svg";

export default function StatsCards() {
  const stats = [
    {
      icon: img1,
      value: 90,
      description: "de proyectos ganados",
    },
    {
      icon: img3,
      value: 60,
      description: "del Market Share",
    },
    {
      icon: img4,
      value: 60,
      description: "clientes de últimos 3 años",
    },
  ];

  return (
    <div className="flex flex-col md:flex-row mt-[70px] md:mt-[100px] lg:mt-[90px]  mb-[70px] md:mb-[100px] lg:mb-[90px] justify-center items-center gap-10 container">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="relative w-[240px] h-[330px]  bg-transparent shadow-[0px_8px_28px_-9px_rgba(0,0,0,0.45)] dark:border dark:border-sidom-orange rounded-[16px] overflow-hidden flex flex-col items-center justify-center text-center p-4"
        >
          <div className="absolute -left-1/2 -top-[70%] w-[540px] h-[700px] rounded-[40%] bg-sidom-blue animate-[spin_20s_linear_infinite]"></div>
          <div
            className="absolute top-[210px] -left-1/2 w-[540px] h-[700px] opacity-80 rounded-[40%] animate-[spin_15s_linear_infinite]"
            style={{
              background:
                "linear-gradient(744deg, #ED7850, #ED7850 60%, #ED7850)",
            }}
          ></div>
          <div
            className="absolute top-[210px] -left-1/2 w-[540px] h-[700px] opacity-90 rounded-[40%] animate-[spin_10s_linear_infinite]"
            style={{
              background:
                "linear-gradient(744deg, #ED7850, #ED7850 60%, #ED7850)",
            }}
          ></div>

          <div className="relative  z-10 flex flex-col items-start justify-center   mb-28">
            <div className="flex items-center justify-center  w-full">
              <img
                src={stat.icon}
                alt="icono"
                className="w-14 h-14 object-contain"
              />
            </div>

            <div className="relative z-10 text-5xl text-center font-bold w-full mt-5 text-sidom-light">
              {stat.value} %
            </div>
            <div className="relative w-full z-10 mt-2 text-sidom-light">
              {stat.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
